import React from "react";

import {FiClock, FiMail, FiFacebook, FiInstagram, FiTwitter} from '../assets/icons/vander'

export default function Tagline(){
    return(
        <>
        <div className="tagline bg-slate-900">
            <div className="container relative">
                <div className="grid grid-cols-1">
                    <div className="flex items-center justify-between">
                        <ul className="list-none space-x-2">
                            <li className="inline-flex items-center">
                                <FiClock className="text-red-500 size-4"></FiClock>
                                <span className="ms-2 text-slate-300">Lun a Sáb: 9:00 a 18:00</span>
                            </li>
                        </ul>

                        <ul className="list-none">
                            <li className="inline-flex items-center">
                                <FiMail className="text-red-500 size-4"></FiMail>
                                <a href="mailto:turismo@cmsystem.cl" className="ms-2 text-slate-300 hover:text-slate-200">turismo@cmsystem.cl</a>
                            </li>
                            <li className="inline-flex items-center ms-2">
                                <ul className="list-none space-x-3">
                                    <li className="inline-flex mb-0"><a href="#!" aria-label="Facebook" className="text-slate-300 hover:text-red-500"><FiFacebook className="size-4 align-middle" aria-hidden="true"></FiFacebook></a></li>
                                    <li className="inline-flex ms-2 mb-0"><a href="#!" aria-label="Instagram" className="text-slate-300 hover:text-red-500"><FiInstagram className="size-4 align-middle" aria-hidden="true"></FiInstagram></a></li>
                                    <li className="inline-flex ms-2 mb-0"><a href="#!" aria-label="Twitter" className="text-slate-300 hover:text-red-500"><FiTwitter className="size-4 align-middle" aria-hidden="true"></FiTwitter></a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
